// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"eb24aba5","453":"c70ebf36"}[chunkId] + ".chunk.js";
};